module.exports = __webpack_public_path__ + "img/logo-mo-30.2f7eda80.svg";